import { render, staticRenderFns } from "./ApproveInvoices.vue?vue&type=template&id=4c44a386&scoped=true&"
import script from "./ApproveInvoices.vue?vue&type=script&lang=js&"
export * from "./ApproveInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ApproveInvoices.vue?vue&type=style&index=0&id=4c44a386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44a386",
  null
  
)

export default component.exports